export const Prices = [
    {
      _id: 0,
      name: "Rs.0 to 99",
      array: [0, 100],
    },
    {
      _id: 1,
      name: "Rs.100 to 499",
      array: [100,499],
    },
    {
      _id: 4,
      name: "Rs.500 or 999",
      array: [500,999],
    },
    {
      _id: 4,
      name: "Rs.1000 or more",
      array: [1000, 9999],
    },
  ];